import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import DashboardHeader from "../../components/auth/DashboardHeader";
import Sidebar from "../../components/auth/Sidebar";
import { Loader } from "../../components/Loader";
import axios from "axios";
import { toast } from "react-toastify";

const SendWithdrawFiat = () => {
  const location = useLocation();
  const { appId } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [appInfo, setAppInfo] = useState("");
  const [receiverAddress, setReceiverAddress] = useState("");
  const [withdrawAmount, setWithdrawAmount] = useState("");

  const [selectedNetwork, setSelectedNetwork] = useState("");
  const [convertedValue, setConvertedValue] = useState("");

  const [note, setNote] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const fetchApp = async () => {
      try {
        setIsLoading(true);
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/apps/getById?appId=${appId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        console.log("RESSS", res);
        const data = res?.data;
        setAppInfo(data);
        setIsLoading(false);
      } catch (err) {
        console.log("Error:", err);
        setIsLoading(false);
      }
    };

    if (appId) fetchApp();
  }, [appId]);

  // ----------------------------------------------------
  // Convert USD → CRYPTO (ETH/BNB/POL)
  // ----------------------------------------------------
  // -------------------------------------------
  // Convert USD → CRYPTO (ETH / BNB / POL)
  // -------------------------------------------
  useEffect(() => {
    const convertAmount = async () => {
      if (!withdrawAmount || !selectedNetwork) return;

      try {
        const amountNumber = Number(withdrawAmount);
        if (!amountNumber || amountNumber <= 0) return;

        // deduct 5% fee
        const withdrawFee = amountNumber * 0.05;
        const amountAfterFee = amountNumber - withdrawFee;

        // Map selected network to Tatum Symbol
        let symbol = selectedNetwork;
        if (symbol === "POL") symbol = "MATIC"; // Tatum mostly uses MATIC
        if (symbol.includes("USDT")) symbol = "USDT";
        if (symbol.includes("USDC")) symbol = "USDC";

        // Call Backend Proxy
        // We need price of SYMBOL in USD
        const response = await axios.post(`${process.env.REACT_APP_API_URL}/common/price`, {
          currency: "USD",
          symbol: symbol
        }, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        if (response?.data?.success && response?.data?.data) {
          const price = response.data.data[symbol];
          if (!price) return;

          const converted = amountAfterFee / price;
          setConvertedValue(converted.toFixed(8));
        }

      } catch (e) {
        console.log("Conversion error:", e);
      }
    };

    convertAmount();
  }, [withdrawAmount, selectedNetwork]);

  const handleRequestWithdrawal = async () => {
    const minWithdraw = 5; // Minimum withdrawal
    const maxWithdraw = appInfo?.totalFiatToUsd || 0;

    // Validation checks
    if (!withdrawAmount) {
      toast.error("Please enter withdrawal amount");
      return;
    }

    if (!selectedNetwork) {
      toast.error("Please select a network");
      return;
    }

    if (withdrawAmount < minWithdraw) {
      toast.error(`Minimum withdrawal amount is ${minWithdraw} USD`);
      return;
    }

    if (withdrawAmount > maxWithdraw) {
      toast.error(
        `Withdrawal amount cannot exceed your balance (${maxWithdraw} USD)`
      );
      return;
    }

    if (!receiverAddress) {
      toast.error("Please enter receiver address");
      return;
    }

    // If everything is valid
    try {
      const amountNumber = Number(withdrawAmount);
      const withdrawFee = amountNumber * 0.05;
      const amountAfterFee = amountNumber - withdrawFee;

      const payload = {
        appsId: appId,
        totalFiatBalance: appInfo?.totalFiatToUsd,
        minimumWithdrawl: 5,
        withdrawlAmount: Number(withdrawAmount),
        // withdrawlAmount: amountAfterFee, // ✔️ 5% deducted amount

        currency: selectedNetwork,
        cryptoValue: Number(convertedValue),
        walletAddress: receiverAddress,
        note: note,
        withdrawlFee: withdrawFee,
      };

      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/merchant-app-tx/merchant-fiat-withdraw`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      toast.success("Withdrawal Requested Successfully!");

      if (res?.data?.success) {
        navigate("/fiat-transactions");
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response?.data?.message || "Failed to withdraw");
    }
  };

  console.log("appInfo", appInfo);

  return (
    <>
      <DashboardHeader />

      <div className="site-bg">
        <div className="dashborad-content-bg">
          <aside className="sidebar">
            <Sidebar />
          </aside>
          <div className="dashborad-warper" style={{ position: "relative" }}>
            {isLoading && <Loader inline={true} />}
            <div className="transactions-list">
              <div className="dashborad-head">
                <div className="breadcrumb-menu">
                  <ul>
                    <li className="active">
                      <Link to="/apps">Apps &rarr; </Link>
                    </li>
                    <li className="active">
                      <Link to={`/apps-detail/${appId}`}>
                        {appInfo?.data?.name}
                      </Link>
                    </li>
                    <li>
                      <a>&rarr; Send/Withdraw</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="white-bg my-apps-content padd20">
                <div className="send-withdraw-list">
                  <ul>
                    <li>
                      <div className="send-withdraw-left">
                        Total Fiat Balance
                      </div>
                      <div className="send-withdraw-right">
                        {appInfo?.totalFiatToUsd} USD
                      </div>
                    </li>

                    <li>
                      <div className="send-withdraw-left">
                        Minimum Withdrawal
                      </div>
                      <div className="send-withdraw-right">5 USD</div>
                    </li>

                    {/* <li>
                      <div className="send-withdraw-left">Current Balance</div>
                      <div className="send-withdraw-right">
                        {appInfo?.totalFiatToUsd} USD
                      </div>
                    </li> */}

                    <li>
                      <div className="send-withdraw-left">
                        Send / Withdrawal Amount
                      </div>
                      <div className="send-withdraw-right">
                        <div className="send-withdraw-amount">
                          <div
                            className="withdraw-amount-fild"
                            style={{
                              display: "flex",
                              gap: "10px",
                              alignItems: "center",
                            }}
                          >
                            {/* Left Column – Amount */}
                            <div style={{ flex: 1 }}>
                              <input
                                type="number"
                                value={withdrawAmount}
                                onChange={(e) =>
                                  setWithdrawAmount(e.target.value)
                                }
                                className="form-control"
                                placeholder="Enter Amount"
                              />
                            </div>

                            {/* Right Column – Network Select */}
                            <div style={{ width: "180px" }}>
                              <select
                                className="form-control"
                                value={selectedNetwork}
                                onChange={(e) =>
                                  setSelectedNetwork(e.target.value)
                                }
                              >
                                <option value="">Select Network</option>
                                <option value="ETH">ETH</option>
                                <option value="BNB">BNB</option>
                                <option value="POL">POL</option>
                                <option value="BTC">BTC</option>
                                <option value="TRX">TRX</option>

                                <option value="USDT.BNB">USDT (BNB)</option>
                                <option value="USDT.ETH">USDT (ETH)</option>
                                <option value="USDT.MATIC">USDT (MATIC)</option>
                                <option value="USDT.TRX">USDT (TRX)</option>
                                <option value="USDC.BNB">USDC (BNB)</option>
                                <option value="USDC.ETH">USDC (ETH)</option>
                                <option value="USDC.MATIC">USDC (MATIC)</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>

                    {/* FINAL PREFILLED VALUE BOX */}
                    <li>
                      <div className="send-withdraw-left">Converted Value</div>
                      <div className="send-withdraw-right">
                        <input
                          type="text"
                          value={convertedValue}
                          className="form-control"
                          readOnly
                          placeholder="Converted Value"
                        />
                      </div>
                    </li>

                    <li>
                      <div className="send-withdraw-left">Send To</div>
                      <div className="send-withdraw-right">
                        <div className="address-note-box">
                          <input
                            type="text"
                            value={receiverAddress}
                            className="form-control"
                            placeholder="Enter Address"
                            onChange={(event) => {
                              setReceiverAddress(event.target.value);
                            }}
                            required
                          />
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="send-withdraw-left">Optional Note</div>
                      <div className="send-withdraw-right">
                        <div className="address-note-box">
                          <input
                            type="text"
                            value={note}
                            className="form-control"
                            placeholder="Enter Note"
                            onChange={(event) => {
                              setNote(event.target.value);
                            }}
                          />
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div
                  className="request-withdrawal-btn"
                  onClick={handleRequestWithdrawal}
                >
                  <button className="btn">Request Withdrawal/Send</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SendWithdrawFiat;
